namespace Areas.Account.RechargeSummary {
    "use strict";

    export function goToActions(sharePointLink: string, projectInfoId: number) {
        return (e: any) => {
            if (e.value == 1) {
                goToSharePoint(sharePointLink);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }

    export function goToSharePoint(sharePointLink) {
        let linkInfo = "https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjects/" + sharePointLink + "/";
        if (sharePointLink != "") {
            window.open(linkInfo);
        }
        else {
            window.open("https://ucla.sharepoint.com/sites/CapitalPrograms/ActiveProjectsList");
        }
    }

    export function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        if (projectInfoId != 0) {
            window.open(linkInfo);
        }

    }
}